import React, {useState} from 'react';
import {
    Button,
    Card,
    Container, Modal, ModalBody, ModalFooter, ModalHeader, Spinner,
} from "reactstrap";
import 'react-phone-number-input/style.css'
import PhoneInput,{isPossiblePhoneNumber} from 'react-phone-number-input'
import API from "../../utils/API";
import Lead from "../leads/Lead";
import InfutorDataDisplay from "./InfutorDataDisplay";

const InfutorDataLookUp = () => {
    const [user, setUser] = useState({phone: null, firstName: null, lastName: null, address: null, city: null, state: null, zip: null});
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false);
    const [phoneError, setPhoneError] = useState(null);

    const [result, setResult] = useState(null);
    const [modalshow, setModalshow] = useState(false);

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value })
        setError(null)
    };

    const setPhone = (phone) => {
        if (phone && phone.length > 0) {
            if (isPossiblePhoneNumber(phone)) {
                setUser({...user, phone: phone});
                setPhoneError(null);
            } else {
                if (phone.replace(/\D/g, '').length >= 10) {
                    setPhoneError('Invalid phone number')
                } else {
                    setPhoneError(null);
                }
            }
        }else {
            setUser({...user, phone: null});
            setPhoneError(null);
        }
    }

    const lookup = () => {
        if (user.phone) {
            setLoading(true);
            API.post("/admin/scrubber/infutorphonelookup",user).then((response) => {
                setLoading(false);
                setResult(response.data.data);
                setModalshow(true);
            });
        }else {
            setError('Phone number is required')
        }
    }

    return <Container fluid className="p-0">
        <h1 className="h3 mb-3">Infutor Data Lookup</h1>
        <Card className="mt-2 p-3">
            {error &&
                <div className="text-center text-danger">{error}</div>
            }
            <div className="justify-content-center d-flex">
            <div className="align-items-center">
                <div className='form-group' style={{width:'400px'}}>
                    <label className="font-weight-bold font-size-lg">Phone *</label>
                    <PhoneInput
                        defaultCountry="US"
                        placeholder="Enter phone number"
                        value={user.phone}
                        countries={['US']}
                        onChange={setPhone}
                        addInternationalOption={false}
                        international={false}
                        className="form-control inputNoBorders"
                    />
                    {phoneError && <div className="text-danger">{phoneError}</div>}
                </div>
                <div className='form-group' style={{width:'400px'}}>
                    <label className="font-weight-bold font-size-lg">First Name</label>
                    <input type="text" className="form-control" name="firstName" value={user.firstName} onChange={handleChange} />
                </div>
                <div className='form-group' style={{width:'400px'}}>
                    <label className="font-weight-bold font-size-lg">Last Name</label>
                    <input type="text" className="form-control" name="lastName" value={user.lastName} onChange={handleChange} />
                </div>
                <div className='form-group' style={{width:'400px'}}>
                    <label className="font-weight-bold font-size-lg">Address</label>
                    <input type="text" className="form-control" name="address" value={user.address} onChange={handleChange} />
                </div>
                <div className='form-group' style={{width:'400px'}}>
                    <label className="font-weight-bold font-size-lg">City</label>
                    <input type="text" className="form-control" name="city" value={user.city} onChange={handleChange} />
                </div>
                <div className='form-group' style={{width:'400px'}}>
                    <label className="font-weight-bold font-size-lg">State</label>
                    <select className="form-control" name="state" value={user.state} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                    </select>
                </div>
                <div className='form-group' style={{width:'400px'}}>
                    <label className="font-weight-bold font-size-lg">Zip</label>
                    <input type="text" className="form-control" name="zip" value={user.zip} onChange={handleChange} />
                </div>
                <div className='form-group text-center' style={{width:'400px'}}>
                    <button className="btn btn-primary btn-lg" style={{width: '200px'}} onClick={()=>lookup()}>{loading ? <Spinner size={'sm'}/> : 'Submit'}</button>
                </div>
            </div>
            </div>
        </Card>
        {result &&
            <>
                <React.Fragment>
                    <Modal
                        isOpen={modalshow}
                        toggle={() => {
                            if (modalshow) {
                                setModalshow(false);
                            }
                            setModalshow(!modalshow)
                        }}
                        size="lg"
                        style={{maxWidth: '1200px', width: '90%'}}
                        onClose={() => setModalshow(false)}
                    >
                        <ModalHeader toggle={() => {
                            if (modalshow) {
                                setModalshow(false);
                            }
                            setModalshow(!modalshow)
                        }}>
                            Infutor Reverse Phone Lookup
                        </ModalHeader>
                        <ModalBody style={{backgroundColor:"#F7F9FC"}}>
                            <InfutorDataDisplay data={result}/>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={() => {setModalshow(false);}}>
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </React.Fragment>
            </>
        }
    </Container>
}

export default InfutorDataLookUp;
